import { styled } from '@mui/material';
import Badge from '@mui/material/Badge';

export const Wrapper = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 3,
  display: 'flex',
  height: 54,
  boxShadow: '0 2px 6px rgba(42, 70, 94, 0.12)',
  padding: '12px 32px',
  backgroundColor: theme.palette.common.white,
}));

export const RightBlock = styled('div')(() => ({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    width: 16,
    height: 16,
    color: theme.palette.common.white,
    fontSize: '0.875rem',
    minWidth: 'auto',
    top: 2,
    right: 2
  }
}));
